import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija para móvil. Aparece una vez que el hero quedó atrás y
 * se oculta al llegar al footer para no interferir con la navegación.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const scrolledPastHero = window.scrollY > window.innerHeight * 0.85;
      const footer = document.getElementById('site-footer');
      const footerReached = footer ? footer.getBoundingClientRect().top <= window.innerHeight : false;
      setVisible(scrolledPastHero && !footerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-stone bg-ivory/95 backdrop-blur transition-transform duration-300 md:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-187" data-mp="2iemeb7mcmjwf">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-188" data-mp="2x651pqhjfgpt">
        <div className="min-w-0" data-id="element-189" data-mp="323wvkq1qtcwn">
          <p className="truncate font-sans text-[0.66rem] font-medium uppercase tracking-[0.12em] text-charcoal/60" data-id="element-190" data-mp="36505kvx40epy">
            Wellness Digital PRO
          </p>
          <p className="font-sans text-lg font-bold leading-tight tracking-tight tabular-nums text-charcoal" data-id="element-191" data-mp="17r6xrx897jjz">
            {PRICE.current}
          </p>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="flex min-h-[44px] max-w-[10.5rem] shrink-0 items-center justify-center rounded-full bg-gold px-4 py-2 text-center font-sans text-[0.6rem] font-bold uppercase leading-[1.15] tracking-[0.1em] text-charcoal transition-colors hover:bg-gold-deep hover:text-ivory focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50" data-id="element-192" data-mp="2f13dzgzsti76">
          Quiero que mi Instagram convierta
        </a>
      </div>
    </div>;
}